module.exports = __webpack_public_path__ + "static/media/19_blanco.29ca36af.svg";